import { render, staticRenderFns } from "./dingzhi-layout.vue?vue&type=template&id=474cbd67&scoped=true&"
import script from "./dingzhi-layout.vue?vue&type=script&lang=js&"
export * from "./dingzhi-layout.vue?vue&type=script&lang=js&"
import style0 from "./dingzhi-layout.vue?vue&type=style&index=0&id=474cbd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474cbd67",
  null
  
)

export default component.exports